import { z } from "zod";
import { EmailEventStatus, EmailType } from "@/gql/graphql";
import { createRoute } from "@tanstack/react-router";
import { EmailEventTableScreen } from "@/app/EmailEvents/Screens/EmailEventTableScreen";
import { appLayoutRoute } from "@/routes/layout-routes";

const emailEventSearchParams = z.object({
  emailEventStatus: z
    .array(z.nativeEnum(EmailEventStatus))
    .optional()
    .catch(undefined),
  emailEventType: z.array(z.nativeEnum(EmailType)).optional().catch(undefined),
  emailEventSearch: z.string().optional(),
});

export type EmailEventListSearchParams = z.infer<typeof emailEventSearchParams>;

export const emailEventsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/emails",
  component: EmailEventTableScreen,
  validateSearch: emailEventSearchParams,
  head: () => ({
    meta: [
      { title: "Email Events - Imoova Admin" },
      { name: "description", content: "View email events" },
    ],
  }),
});
